import React from 'react'
import { useTranslation } from 'react-i18next'
import { Loader2 } from 'lucide-react'

// Square card for a single capture in the reveal view. Used by both
// MomentsPage (today's pair on the index) and MomentsCapturePage (the
// stacked reveal after submitting). Late captures get a small amber
// badge so the asymmetry from PR A's strict-reveal trigger reads
// visually: late pairs never flip status='revealed', so this badge
// is the only signal that "yes, both of us showed up, but not in
// time to count for streak."
export default function MomentsCaptureCard({ label, imageUrl, late }) {
  const { t } = useTranslation()
  return (
    <div className="relative aspect-square overflow-hidden rounded-2xl bg-neutral-200 dark:bg-neutral-800">
      {imageUrl ? (
        <img src={imageUrl} alt="" className="h-full w-full object-cover" />
      ) : (
        <div className="absolute inset-0 grid place-items-center">
          <Loader2 className="h-5 w-5 animate-spin opacity-60" />
        </div>
      )}
      <div className="absolute bottom-2 start-2 rounded-full bg-black/55 px-3 py-1 text-xs font-medium text-white">
        <span dir="auto">{label}</span>
      </div>
      {late && (
        <div className="absolute end-2 top-2 rounded-full bg-amber-500/90 px-2 py-0.5 text-[10px] font-medium text-white">
          <span dir="auto">{t('moments.lateBadge')}</span>
        </div>
      )}
    </div>
  )
}
